import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import BottomPopupDropdownOptions from '@components/BottomPopupDropdownOptions';
import CommonImage from '@components/CommonImage';
import AddDesignToCollection from '@components/design-uploads/AddDesignToCollection';
import DesignItem from '@components/DesignItem';
import LoaderComponent from '@components/LoaderComponent';
import { toastSuccess } from '@components/Toast';

import useWindowSize from '@hooks/useWindowSize';

import InventoryAndStickerModal from '@features/favourites/components/InventoryAndStickerModal';
import SampleLocationDetailsModal from '@features/favourites/components/SampleLocationDetailsModal';
import SelectFolderPopup from '@features/favourites/components/SelectFolderPopup';
import UpdateSampleLocation from '@features/favourites/components/UpdateSampleLocation';
import FilterTopHeader from '@features/filter/FilterTopHeader';
import {
	allFilterPages,
	designFieldList,
	generateProductListParams
} from '@features/filter/static/filterUtil';
import FilterComponent from '@features/filter/v2/FilterComponent';
import PublishDesign from '@features/collection/components/PublishDesign';

import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';
import { handleFilter } from '@store/actions/FilterAction';
import { closeLoader } from '@store/actions/LoaderAction';
import { likeProduct } from '@store/design/action';
import { removeSearchResult } from '@store/searchOptions/actions';

import { fetchDependentFilterList } from '@services/commonService';
import { getPickAndChoosePrice, toggleDesignHideFromBuyer } from '@services/productService';

import { isAdmin, isFashionDesigner, isPageReachBottom, showDesignViewPage } from '@utils/Util';

import { LIST_VIEW_TYPE, SAMPLE_REQUEST_TYPES } from '@/constants/constant';

import { useDownloadTpSummaryMutation } from '@/api/commonDownloadsApi';
import { useGetRequestTasksQuery } from '@/api/commonApis';
import AddTaskModal from '@/components/AddTaskModal';
import { ENTITY_TYPE } from '@/components/rangePlan/constants';
import { storeProductData } from '@/store/actions/DesignAction';
import SampleRequestModal from '@/features/sampleDevelopment/components/SampleRequestModals/SampleRequestModal';
import RequestTo3DAndGraphicsModal from '@/features/sampleDevelopment/components/SampleRequestModals/RequestTo3DAndGraphicsModal';
import { getUserTypeFromTaskValue } from '@/features/sampleDevelopment/utils';
import PhysicalSampleRequestModal from '@/features/sampleDevelopment/components/SampleRequestModals/PhysicalSampleRequestModal';

const DesignListV2 = ({
	viewType,
	onClickTab,
	onSetDefaultView,
	pathName,
	selectedTab,
	selectedProductId,
	setIsSetParam,
	isSetParamExist = false
}) => {
	const [loader, setLoader] = useState(true);
	const [showAddCollectionPopup, setShowAddCollectionPopup] = useState(false);
	const filterData = useSelector((store) => store.filterFieldStore);
	const [designIdList, setDesignIdList] = useState([]);
	const [showFilter, setShowFilter] = useState(false);
	const [isOpenDesign, setIsOpenDesign] = useState(false);
	const [selectedProducts, setSelectedProducts] = useState([]);
	const [idsForOfferPrice, setIdsForOfferPrice] = useState([]);
	const [allOfferPrices, setAllOfferPrices] = useState([]);
	const [activeTab, setActiveTab] = useState('');
	const [page] = useState(0);
	const dispatch = useDispatch();
	const myStateRef = useRef({});
	const isDataLoading = useRef(false);
	const [designIdToView, setDesignIdToView] = useState(null);
	const [designList, setDesignList] = useState(null);
	const [isDefaultOpenBasicInfo, setIsDefaultOpenBasicInfo] = useState(false);
	const filterResponse = useSelector((store) => store.filterResponseStore);
	const isShowPriceTypeStore = useSelector((store) => store.systemPreferenceReducer);
	const [isShowPrice, setIsShowPrice] = useState(isShowPriceTypeStore);
	const mentionedData = useSelector((store) => store.chatReducer.mentionedData);
	let filterfields = useSelector((store) => store.filterFieldStore);
	const sortValue = filterfields['sort'] && filterfields['sort'][0]?.key;
	const { ...paramsData } = generateProductListParams(filterfields);
	useWindowSize(() => setShowFilter(false));
	const [isInventoryModalOpen, setIsInventoryModalOpen] = useState(false);
	const [isShowLocationModal, setIsShowLocationModal] = useState(false);
	const [selectedLocationsToDownload, setSelectedLocationsToDownload] = useState([]);
	const [isShowUpdateLocationModal, setIsShowUpdateLocationModal] = useState(false);
	const [isShowDesignersTechpack, setIsShowDesignersTechpack] = useState(false);
	const { searchResult, isViwTechpack, isAddToFavourite } = useSelector(
		(store) => store.collectionSearchOptionStore
	);
	const [isShowFavouriteFolderPopup, setIsShowFavouriteFolderPopup] = useState(false);
	const [isShowCreateNew, setIsShowCreateNew] = useState(false);
	const [currentLikedStyle, setCurrentLikedStyle] = useState(null);
	const updatedArchivedProductId = useSelector(
		(store) => store.collectionSearchOptionStore.updatedArchivedProductId
	);
	const [isShowPublishModal, setIsShowPublishModal] = useState(false);
	const [isShowUpdateTaskModal, setIsShowUpdateTaskModal] = useState(false);
	// const [taskInputValueFromTaskModal, setTaskInputValueFromTaskModal] = useState('');
	// const [isShowAddNewTaskModal, setIsShowAddNewTaskModal] = useState(false);
	const [showAddSamplePopup, setShowAddSamplePopup] = useState(false);
	const [isShowSendToPdModal, setIsShowSendToPdModal] = useState(false);
	const [isShowSendToFactoryNitexModal, setIsShowSendToFactoryNitexModal] = useState(false);
	const [isShowSendToFactoryBuyerModal, setIsShowSendToFactoryBuyerModal] = useState(false);
	const [isShowSendTo3DModal, setIsShowSendTo3DModal] = useState(false);
	const [isShowSendToGraphicsModal, setIsShowSendToGraphicsModal] = useState(false);
	const [folderId] = useState(null);
	const { data: requestTypes = [] } = useGetRequestTasksQuery({ params: { type: 'REQUEST' } });
	const location = useLocation();
	const [downloadTpSummary] = useDownloadTpSummaryMutation();
	const [isUnSelectAll, setIsUnSelectAll] = useState(false);
	const [isSelectOnNextPage, setIsSelectOnNextPage] = useState(false);
	const [previousDataLength, setPreviousDataLength] = useState(0);
	const [isShowTechpackHandoverModal, setIsShowTechpackHandoverModal] = useState(false);
	const [selectedProductActionId, setSelectedProductActionId] = useState(null);
	const [selectedHandoverUserType, setSelectedHandoverUserType] = useState(null);
	const [isShowPublishDesign, setIsShowPublishDesign] = useState(false);
	const [failedTaskUpdateIds, setFailedTaskUpdateIds] = useState([]);
	const [isShowReviseSampleModal, setIsShowReviseSampleModal] = useState(false);
	const [isShowPhysicalSampleModal, setIsShowPhysicalSampleModal] = useState(false);

	const onUpdateHasMentioned = (productId) => {
		let productList = designList?.data?.map((item) => {
			if (item.id === productId) {
				return {
					...item,
					hasUnseenMention: true
				};
			}
			return item;
		});
		setDesignList({ data: productList });
	};

	useEffect(() => {
		if (mentionedData?.productId) {
			onUpdateHasMentioned(mentionedData?.productId);
		}
	}, [mentionedData]);

	useEffect(() => {
		if (selectedProductId) {
			setDesignIdToView(selectedProductId);
		}
	}, [selectedProductId]);

	useEffect(() => {
		if (searchResult) {
			setDesignIdToView(searchResult);
		}
	}, [searchResult]);

	useEffect(() => {
		setIsShowPrice(isShowPriceTypeStore);
	}, [isShowPriceTypeStore]);

	const setIsDataLoading = (data) => {
		isDataLoading.current = data;
	};

	const setMyState = (data) => {
		myStateRef.current = data;
	};

	const generateSortParams = () =>
		pathName === '/nitex-studio' ? '&sort=dateAdded,desc' : '&sort=id,desc';

	useEffect(() => {
		setDesignList(filterResponse);
	}, [filterResponse]);

	useEffect(() => {
		setMyState(designList);
		let designIds = designList?.data
			?.filter((product) => product.extraFlag && showDesignViewPage(product))
			.map((product) => product.id);
		setDesignIdList(designIds);
	}, [designList]);

	const removeAvailabilityStatusAll = (data) => {
		if (Array.isArray(data.availabilityStatusList)) {
			const index = data.availabilityStatusList.indexOf('ALL');
			if (index > -1) {
				data.availabilityStatusList.splice(index, 1);
			}

			if (data.availabilityStatusList.length === 0) {
				if (pathName === '/nitex-studio') {
					data.isNitexStudioPublishedTab = true;
					delete data.availabilityStatusList;
				} else {
					delete data.availabilityStatusList;
				}
			}
		}

		if (Object.prototype.hasOwnProperty.call(data, 'sort')) {
			delete data['sort'];
		}

		return data;
	};

	// Extract handoverRequestId from URL to use as dependency
	const handoverRequestId = useMemo(() => {
		const params = new URLSearchParams(location.search);
		return params.get('handoverRequestId');
	}, [location.search]);

	useEffect(() => {
		let activeTab = filterData?.availabilityStatusList || [];
		let currentTabOfGlobal = activeTab.find((item) => item.type === 'SELECT');

		window.scrollTo(0, 0);
		setLoader(true);
		setIsDataLoading(true);
		let requestBody = generateProductListParams(filterfields, '');
		requestBody = removeAvailabilityStatusAll(requestBody);

		if (currentTabOfGlobal?.key === 'Sold' && isShowDesignersTechpack) {
			requestBody.isSoldDesignerStyle = true;
		}
		if (currentTabOfGlobal?.key === 'Sold' && !isShowDesignersTechpack) {
			requestBody.isSoldDesignerStyle = false;
		}
		if (currentTabOfGlobal?.key === 'Sold') {
			delete requestBody.availabilityStatusList;
		}
		let queryString = `?page=${page}&size=30`;
		mergeSoldDesignParams(requestBody);
		queryString += filterfields.sort === undefined ? generateSortParams() : `&sort=${sortValue}`;

		if (handoverRequestId) {
			requestBody.handoverRequestId = parseInt(handoverRequestId);
		}

		if (requestBody.availabilityStatusList) {
			delete requestBody.availabilityStatusList;
		}

		dispatch(
			handleFilter('getManageProducts', queryString, false, 'POST', requestBody, isViwTechpack, false)
		).finally(() => {
			setLoader(false);
			setIsDataLoading(false);
		});

		document.addEventListener('scroll', handleScroll);
		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	}, [updatedArchivedProductId, isShowDesignersTechpack, handoverRequestId, filterfields, activeTab]);

	useEffect(() => {
		if (showFilter) {
			const cleanParamsData = removeAvailabilityStatusAll({ ...paramsData });
			if (activeTab === 'Sold' && isShowDesignersTechpack) {
				cleanParamsData.isSoldDesignerStyle = true;
				delete cleanParamsData.availabilityStatusList;
			}
			mergeSoldDesignParams(cleanParamsData);
			dispatch(
				fetchDependentFilterList({ type: 'PRODUCT_LIST' }, cleanParamsData, 'POST', cleanParamsData)
			);
		}
	}, [showFilter, filterData, isShowDesignersTechpack]);

	useEffect(() => {
		let activeTab = filterData?.availabilityStatusList || [];
		let currentTabOfGlobal = activeTab.find((item) => item.type === 'SELECT');
		setActiveTab(currentTabOfGlobal?.key);
	}, [filterData]);

	const onLastDesignReached = () => {
		if (!myStateRef.current) return;
		let { totalElements, currentPage, data } = myStateRef.current;
		let pageNumber = parseInt(currentPage + 1);
		if (totalElements > 0) {
			if (totalElements !== data.length && !isDataLoading.current) {
				setLoader(true);
				setIsDataLoading(true);
				let requestBody = generateProductListParams(filterfields);
				requestBody = removeAvailabilityStatusAll(requestBody);
				delete requestBody.availabilityStatusList;

				if (activeTab === 'Sold' && !isShowDesignersTechpack) {
					requestBody.isSoldDesignerStyle = false;
				}

				if (activeTab === 'Sold' && isShowDesignersTechpack) {
					requestBody.isSoldDesignerStyle = true;
				}

				let queryString = `?page=${pageNumber}&size=30`;
				mergeSoldDesignParams(requestBody);
				queryString += filterfields.sort === undefined ? generateSortParams() : `&sort=${sortValue}`;
				dispatch(
					handleFilter(
						'getManageProducts',
						queryString,
						true,
						'POST',
						requestBody,
						isViwTechpack,
						isAddToFavourite
					)
				).finally(() => {
					dispatch(closeLoader());
					setIsDataLoading(false);
				});
			}
		}
	};

	const handleScroll = () => {
		if (isPageReachBottom() && !isDataLoading.current) {
			onLastDesignReached();
		}
	};

	const mergeSoldDesignParams = (requestBody) => {
		const params = new URLSearchParams(location.search);
		if (params.get('designType') === 'SOLD') {
			requestBody.isSoldDesignerStyle = true;
			requestBody.hasPresentationImage = true;
			delete requestBody.availabilityStatusList;
			delete requestBody.isNitexStudioPublishedTab;
		}
	};

	const onUpdateProductStatus = () => {
		let { currentPage } = myStateRef.current;

		// Prevent multiple simultaneous fetches
		if (isDataLoading.current) return;

		setIsDataLoading(true);
		setLoader(true);

		// Temporarily remove scroll listener during refresh
		document.removeEventListener('scroll', handleScroll);

		let requestBody = generateProductListParams(filterfields);
		requestBody = removeAvailabilityStatusAll(requestBody);
		let queryString = `?page=0&size=${(parseInt(currentPage) + 1) * 30}`;
		mergeSoldDesignParams(requestBody);
		queryString += filterfields.sort === undefined ? generateSortParams() : `&sort=${sortValue}`;

		if (handoverRequestId) {
			requestBody.handoverRequestId = handoverRequestId;
		}

		dispatch(
			handleFilter(
				'getManageProducts',
				queryString,
				false,
				'POST',
				requestBody,
				isViwTechpack,
				isAddToFavourite
			)
		).finally(() => {
			setIsDataLoading(false);
			setLoader(false);
			// Re-add scroll listener after a short delay
			setTimeout(() => {
				document.addEventListener('scroll', handleScroll);
			}, 100);
		});
	};

	const onClickDesignImage = (designId, openBasicInfo = false) => {
		setIsDefaultOpenBasicInfo(openBasicInfo);
		setDesignIdToView(designId?.id);
	};

	const onCloseViewModal = () => {
		if (setIsSetParam) setIsSetParam(false);
		setDesignIdToView(null);
		setIsDefaultOpenBasicInfo(false);
		isOpenDesign && setIsOpenDesign(false);
		dispatch(clearDesignViewModalInfo({}));
		dispatch(removeSearchResult(null));
	};

	useEffect(() => {
		if (designIdToView !== null) {
			openDesignViewModal();
		}
	}, [designIdToView]);

	const openDesignViewModal = () => {
		dispatch(
			setDesignViewModalInfo({
				id: designIdToView,
				isShowMergeTechPack: isSetParamExist,
				onCloseViewModal: onCloseViewModal,
				updateProductStatus: onUpdateProductStatus,
				source: 'PRODUCT_LIST',
				designIdList: designIdList,
				loadMoreDesign: true,
				onLastDesignReached: onLastDesignReached,
				isDefaultOpenBasicInfo: isDefaultOpenBasicInfo
			})
		);
	};

	const onSetLike = (id) => {
		const productList = designList?.data.map((item) => {
			if (item.id === id) {
				return {
					...item,
					liked: true
				};
			}
			return item;
		});
		setDesignList({ ...designList, data: productList });
	};

	// const onSetUnlike = (id) => {
	// 	const productList = designList?.data.map((item) => {
	// 		if (item.id === id) {
	// 			return {
	// 				...item,
	// 				liked: false
	// 			};
	// 		}
	// 		return item;
	// 	});
	// 	setDesignList({ ...designList, data: productList });
	// };

	const handleSuccessLikeProduct = () => {
		!isShowFavouriteFolderPopup && setIsShowFavouriteFolderPopup(true);
		toastSuccess('Added to favourite');
	};

	const onLikeProduct = async (id) => {
		onSetLike(id);
		setIsShowFavouriteFolderPopup(true);
		await dispatch(likeProduct(id, handleSuccessLikeProduct));
		setCurrentLikedStyle(id);
	};

	const isMyDesignTab = () => {
		return filterData?.filterCategory?.some((item) => {
			if (item?.type === 'SELECT' && item?.value === 'MY_DESIGN') return true;
			return false;
		});
	};

	const downloadReportByProductIds = () => {
		downloadTpSummary({
			productIds: selectedProducts,
			inventoryCountryIds: selectedLocationsToDownload
		})
			.unwrap()
			.then(() => {
				setIsShowLocationModal(false);
				setSelectedLocationsToDownload([]);
			});
	};

	const handleDownload = (type) => {
		if (type === 'DOWNLOAD_REPORT') {
			downloadReportByProductIds();
		} else if (type === 'SAMPLE_LOCATION_DETAILS') {
			setIsShowLocationModal(true);
		}
	};

	const getOfferPriceForProduct = async () => {
		setLoader(true);
		try {
			const response = await getPickAndChoosePrice(idsForOfferPrice);
			setAllOfferPrices((prevPrices) => ({
				...prevPrices,
				...response
			}));
			setLoader(false);
		} catch {
			setLoader(false);
		}
	};

	useEffect(() => {
		if (designList?.data?.length > 0) {
			const currentIds = designList.data.map((design) => design.id);
			if (myStateRef.current?.currentPage === 0) {
				setIdsForOfferPrice(currentIds.slice(0, 48));
			} else {
				setIdsForOfferPrice(currentIds.slice(-12));
			}
		}
	}, [designList]);

	useEffect(() => {
		if (idsForOfferPrice?.length > 0) {
			getOfferPriceForProduct();
		}
	}, [idsForOfferPrice]);

	const handleUpdateDesignOnPublish = (productIds) => {
		const updatedProductList = designList.data.map((product) => {
			if (productIds.includes(product.id)) {
				return {
					...product,
					productStatusList: product.productStatusList.map((status) => ({
						...status,
						entity: 'DESIGN',
						status: 'Published'
					}))
				};
			}
			return product;
		});
		setDesignList({ ...designList, data: updatedProductList });
	};

	const handleProductUpdate = (products) => {
		let productList = designList?.data?.map((item) => {
			const selectedProduct = products.find((product) => product.productId === item.id);
			if (selectedProduct && item.id === selectedProduct.productId) {
				return {
					...item,
					isLocked: selectedProduct.isLocked
				};
			}
			return item;
		});
		setDesignList({ data: productList });
	};

	const onClickToggleDesignHideFromBuyer = (product) => {
		setLoader(true);
		toggleDesignHideFromBuyer(product.id, !product.isHideFromBuyer)
			.then(() => {
				let productList = designList?.data?.map((item) => {
					if (item.id === product.id) {
						return {
							...item,
							isHideFromBuyer: !product.isHideFromBuyer
						};
					}
					return item;
				});
				setDesignList({ data: productList });
			})
			.finally(() => {
				setLoader(false);
			});
	};

	const renderDesignList = () => {
		let isSelected = isMyDesignTab();
		if (designList?.data?.length > 0) {
			return designList.data.map((design, index) => {
				const offerPriceInfo = allOfferPrices[design.id];
				return (
					<DesignItem
						design={design}
						index={index}
						selectedProducts={selectedProducts}
						setSelectedProducts={setSelectedProducts}
						onClickDesignImage={onClickDesignImage}
						key={`design_${index}`}
						onLikeProduct={onLikeProduct}
						fromPage={'DESIGN_PAGE'}
						isMyDesignTabSelected={isSelected}
						isShowPrice={isShowPrice}
						isFromNitexStudio={pathName === '/nitex-studio'}
						offerPriceInfo={offerPriceInfo || []}
						handleProductUpdate={handleProductUpdate}
						onClickToggleDesignHideFromBuyer={onClickToggleDesignHideFromBuyer}
						failedTaskUpdateIds={failedTaskUpdateIds}
					/>
				);
			});
		}
	};

	const clearSelection = () => {
		setSelectedProducts([]);
	};

	const getProductIds = () => {
		return selectedProducts;
	};

	const handleTpHandover = (actionType) => {
		setSelectedProductActionId(actionType?.id);
		setSelectedHandoverUserType(actionType);
		setIsShowTechpackHandoverModal(true);
	};

	const onActionClick = (type, actionType) => {
		switch (type) {
			case 'SEND_TO_SAMPLE_SECTION':
				setShowAddSamplePopup(true);
				break;
			case 'SEND_TO_FACTORY_BUYER_DESIGN':
				setIsShowSendToFactoryBuyerModal(true);
				break;
			case 'SEND_TO_FACTORY_NITEX_DESIGN':
				setIsShowSendToFactoryNitexModal(true);
				break;
			case 'SEND_TO_PD':
				setIsShowSendToPdModal(true);
				break;
			case 'REQUEST_3D':
				setIsShowSendTo3DModal(true);
				break;
			case 'REQUEST_GRAPHICS':
				setIsShowSendToGraphicsModal(true);
				break;
			case 'TP_HANDOVER':
				setSelectedProductActionId(actionType?.id);
				setIsShowTechpackHandoverModal(true);
				break;

			case 'TP_HANDOVER':
				handleTpHandover(actionType);
				break;

			case 'SEND_REVISE_SAMPLE_REQUEST':
				setIsShowReviseSampleModal(true);
				break;

			case 'TP_HANDOVER_TO_PROJECT_TEAM':
				handleTpHandover(actionType);
				break;
			case 'TP_HANDOVER_TO_PATTERN_SECTION':
				handleTpHandover(actionType);
				break;
			case 'TP_HANDOVER_TO_ACCOUNT_MANAGER':
				handleTpHandover(actionType);
				break;
			case 'TP_HANDOVER_TO_DESIGNER':
				handleTpHandover(actionType);
				break;
			case 'INVENTORY_SAMPLE_REQUEST':
				setIsShowPhysicalSampleModal(true);
				break;
			case 'SELECT_ALL':
				setIsUnSelectAll(true);
				handleSelectAll();
				break;
			// case 'PUBLISH':
			// 	setIsShowPublishDesign(true);
			// 	break;
			case 'FETCH_NEXT_PAGE':
				const allCurrentIds = designList?.data?.map((product) => product?.id) || [];
				const unselectedCurrentIds = allCurrentIds.filter((id) => !selectedProducts.includes(id));

				if (unselectedCurrentIds.length >= 30) {
					handleSelectNext30();
				} else if (getRemainingStyles() > 0) {
					setIsSelectOnNextPage(true);
					fetchNextPageForSelection();
				}
				break;

			default:
				break;
		}
	};

	const renderAlertMessage = () => {
		if (designList?.data?.length === 0) {
			return (
				<div className="alert alert-secondary text-center">
					<p>No design found</p>
				</div>
			);
		}
	};

	const getRemainingStyles = () => {
		const totalElements = designList?.totalElements || 0;
		const selectedCount = selectedProducts?.length || 0;
		const remaining = totalElements - selectedCount;

		return remaining < 30 ? remaining : 30;
	};

	const handleSelectAll = () => {
		const designIds = designList?.data?.map((product) => product?.id);
		setSelectedProducts((prevSelected) => [...new Set([...prevSelected, ...designIds])]);
	};

	const handleSelectNext30 = () => {
		const allIds = designList?.data?.map((product) => product?.id) || [];
		const unselectedIds = allIds.filter((id) => !selectedProducts.includes(id));
		const next30Ids = unselectedIds.slice(0, 30);
		setSelectedProducts((prevSelected) => [...new Set([...prevSelected, ...next30Ids])]);
	};

	const renderCollectionModal = () => {
		if (selectedProducts.length > 0) {
			return (
				<div className="design-count-section design-list-count bg-white shadow-8dp">
					<div className="count-info d-flex justify-content-between align-items-center">
						<div className="design-count">
							<p className="semibold-18">{`${selectedProducts?.length}/${designList?.totalElements}`}</p>
						</div>
						{!isUnSelectAll && (
							<>
								<button
									className="button text size36 px-0"
									onClick={(e) => {
										e.stopPropagation();
										onActionClick('SELECT_ALL');
									}}
								>
									<span className="ml-1">Select 1st {designList?.data?.length} Styles</span>
								</button>
								<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
									|
								</span>
							</>
						)}
						{isUnSelectAll && (
							<>
								<button
									className="button text size36"
									onClick={() => onActionClick('FETCH_NEXT_PAGE')}
									disabled={getRemainingStyles() === 0}
								>
									<span className="ml-1">Select Next {getRemainingStyles()} Styles</span>
								</button>
								<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
									|
								</span>
							</>
						)}

						<div className="buttons ">
							<button
								className="button text size36"
								onClick={() => setShowAddCollectionPopup(true)}
							>
								<CommonImage src="/icons/add-round.svg" alt="add" />
								<span className="ml-1">Collection</span>
							</button>
						</div>
						<div className="buttons ">
							<button
								className="button text size36"
								onClick={() => setIsInventoryModalOpen(true)}
							>
								Inventory & Sticker
							</button>
						</div>

						{isAdmin() && isFashionDesigner() && (
							<div className="buttons" onClick={() => setIsShowPublishModal(true)}>
								<button className="button text size36">
									<span className="ml-1">Publish</span>
								</button>
							</div>
						)}
						{requestTypes?.length > 0 && (
							<div className="add-new-design ml-2">
								<button
									className="button text size36 px-0"
									type="button"
									id="moreDropdown5"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									Request
								</button>
								<div className="dropdown-menu" aria-labelledby="moreDropdown5">
									<ul className="dropdown-box">
										{requestTypes
											.filter((type) => {
												return (
													type?.taskValueType?.constant !== 'ORDER_PLACED' &&
													type?.taskValueType?.constant !==
														'BUYER_COSTING_REQUESTED_FROM_BUYER_PLATFORM' &&
													type?.taskValueType?.constant !==
														'BUYER_COSTING_REQUESTED_FROM_AM_BDM' &&
													type?.taskValueType?.constant !==
														'BUYER_COSTING_REQUESTED'
												);
											})
											.map((item) => {
												return (
													<li key={item.id}>
														<span
															onClick={(e) => {
																e.stopPropagation();
																onActionClick(
																	item.taskValueType?.constant,
																	item
																);
															}}
														>
															{item.name}
														</span>
													</li>
												);
											})}
									</ul>
								</div>
							</div>
						)}

						<div className="buttons" onClick={() => setIsShowUpdateTaskModal(true)}>
							<button className="button text size36">
								<span className="ml-1">Update task</span>
							</button>
						</div>
						<div className="buttons" onClick={() => setIsShowPublishDesign(true)}>
							<button className="button text size36">
								<span className="ml-1">Publish</span>
							</button>
						</div>
						<div>
							<BottomPopupDropdownOptions
								onActionClick={handleDownload}
								options={[
									{
										id: 'DOWNLOAD_REPORT',
										title: 'Techpack Summary',
										value: 'DOWNLOAD_REPORT'
									},
									{
										id: 'SAMPLE_LOCATION_DETAILS',
										title: 'Sample Location Details',
										value: 'SAMPLE_LOCATION_DETAILS'
									}
								]}
							/>
						</div>

						<div className="text-right close-icon" onClick={clearSelection}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="25"
								height="24"
								viewBox="0 0 25 24"
								fill="none"
							>
								<path
									d="M18.5038 5.7107C18.1138 5.3207 17.4838 5.3207 17.0938 5.7107L12.2038 10.5907L7.31383 5.7007C6.92383 5.3107 6.29383 5.3107 5.90383 5.7007C5.51383 6.0907 5.51383 6.7207 5.90383 7.1107L10.7938 12.0007L5.90383 16.8907C5.51383 17.2807 5.51383 17.9107 5.90383 18.3007C6.29383 18.6907 6.92383 18.6907 7.31383 18.3007L12.2038 13.4107L17.0938 18.3007C17.4838 18.6907 18.1138 18.6907 18.5038 18.3007C18.8938 17.9107 18.8938 17.2807 18.5038 16.8907L13.6138 12.0007L18.5038 7.1107C18.8838 6.7307 18.8838 6.0907 18.5038 5.7107Z"
									fill="#6A7181"
								/>
							</svg>
						</div>
					</div>
				</div>
			);
		}
	};

	useEffect(() => {
		const currentDataLength = designList?.data?.length || 0;

		if (isSelectOnNextPage && currentDataLength > previousDataLength) {
			handleSelectNext30();
			setIsSelectOnNextPage(false);
			setPreviousDataLength(currentDataLength);
		} else if (designList?.data?.length && !isSelectOnNextPage) {
			setPreviousDataLength(currentDataLength);
		}
	}, [isSelectOnNextPage, designList?.data?.length, previousDataLength]);

	const fetchNextPageForSelection = () => {
		if (!myStateRef.current) return;
		let { totalElements, currentPage, data } = myStateRef.current;

		let nextPageNumber = parseInt(currentPage + 1);

		if (totalElements > 0 && totalElements !== data.length && !isDataLoading.current) {
			setLoader(true);
			setIsDataLoading(true);
			let requestBody = generateProductListParams(filterfields);
			requestBody = removeAvailabilityStatusAll(requestBody);
			if (activeTab === 'Sold' && isShowDesignersTechpack) {
				requestBody.isSoldDesignerStyle = true;
				delete requestBody.availabilityStatusList;
			}
			let queryString = `?page=${nextPageNumber}&size=30`;
			mergeSoldDesignParams(requestBody);
			queryString += filterfields.sort === undefined ? generateSortParams() : `&sort=${sortValue}`;
			dispatch(
				handleFilter(
					'getManageProducts',
					queryString,
					true,
					'POST',
					requestBody,
					isViwTechpack,
					isAddToFavourite
				)
			).finally(() => {
				dispatch(closeLoader());
				setIsDataLoading(false);
			});
		}
	};

	return (
		<LoaderComponent loading={loader}>
			<div className={`${isShowFavouriteFolderPopup ? 'show' : 'hide'}`}>
				<SelectFolderPopup
					onClose={() => setIsShowFavouriteFolderPopup(false)}
					isShowCreateNew={isShowCreateNew}
					setIsShowCreateNew={setIsShowCreateNew}
					currentLikedStyle={currentLikedStyle}
				/>
			</div>
			<FilterTopHeader
				setShowFilter={setShowFilter}
				showFilter={showFilter}
				addNewTitle={'Design'}
				searchBoxPlaceHolder={'Design name & number'}
				onClickTab={onClickTab}
				onSetDefaultView={onSetDefaultView}
				isFromNitexStudio={pathName === '/nitex-studio'}
				viewType={selectedTab}
				pathName={pathName}
				setIsShowFavouriteFolderPopup={setIsShowFavouriteFolderPopup}
				isShowDesignersTechpack={isShowDesignersTechpack}
				setIsShowDesignersTechpack={setIsShowDesignersTechpack}
			/>
			<section
				className={`filter-data-container filter-v3-data-container bg-white py-0 ${
					pathName === '/nitex-studio' ? 'nitex-studio-design' : 'under-inner-tabs'
				}`}
			>
				<FilterComponent
					filterPageName={allFilterPages.PRODUCT_LIST}
					fields={
						pathName === '/nitex-studio'
							? {
									...(activeTab === 'All' && { soldDate: true }),
									...designFieldList,
									mineAndShared: false
								}
							: {
									...(activeTab === 'Sold' && { soldDate: true }),
									...designFieldList
								}
					}
					showFilter={showFilter}
					isDependentFilter={true}
				/>
				<div className="data-table">
					<div className="design-list-container">
						<div
							className={`design-list-row ${
								viewType === LIST_VIEW_TYPE.NARROW_VIEW
									? 'narrow-view'
									: viewType === LIST_VIEW_TYPE.IMAGE_VIEW
										? 'image-view'
										: ''
							}`}
						>
							{renderDesignList()}
						</div>
						{renderAlertMessage()}
					</div>
					{renderCollectionModal()}
				</div>
			</section>
			{isInventoryModalOpen && (
				<InventoryAndStickerModal
					onClose={() => setIsInventoryModalOpen(false)}
					productIds={selectedProducts}
					isDesignEdit={true}
					designList={designList?.data?.map((design) => ({ productResponse: { ...design } }))}
					setIsShowInventoryModal={setIsInventoryModalOpen}
				/>
			)}
			{isShowLocationModal && (
				<SampleLocationDetailsModal
					onClose={() => {
						setIsShowLocationModal(false);
						setSelectedLocationsToDownload([]);
					}}
					downloadReportByProductIds={downloadReportByProductIds}
					selectedLocationsToDownload={selectedLocationsToDownload}
					setSelectedLocationsToDownload={setSelectedLocationsToDownload}
				/>
			)}
			{showAddCollectionPopup && (
				<AddDesignToCollection
					type="ADD_NEW"
					actionType="COPY"
					title="Copy to collection"
					onAddDesign={() => {
						setShowAddCollectionPopup(false);
					}}
					onCancel={async () => {
						setShowAddCollectionPopup(false);
					}}
					designIdList={selectedProducts}
				/>
			)}
			{isShowUpdateLocationModal && (
				<UpdateSampleLocation
					selectedProductIds={selectedProducts}
					setIsShowUpdateLocationModal={setIsShowUpdateLocationModal}
					isOnTheWay
				/>
			)}
			{isShowPublishModal && (
				<PublishDesign
					selectedProducts={selectedProducts}
					onClose={() => {
						dispatch(storeProductData('selectedProductIds', []));
						setIsShowPublishModal(false);
					}}
					onSubmitSuccess={handleUpdateDesignOnPublish}
				/>
			)}
			{isShowUpdateTaskModal && (
				<AddTaskModal
					onClose={() => {
						// if (taskName) {
						// 	setTaskInputValueFromTaskModal(taskName);
						// }
						clearSelection();
						setIsShowUpdateTaskModal(false);
					}}
					// onOpenAddNewTaskModal={() => setIsShowAddNewTaskModal(true)}
					productIdList={selectedProducts}
					onSuccess={() => {
						setSelectedProducts([]);
						onUpdateProductStatus();
					}}
					onError={setFailedTaskUpdateIds}
				/>
			)}
			{/* {isShowAddNewTaskModal && (
				<CreateNewTask
					onClose={() => {
						setIsShowAddNewTaskModal(false);
					}}
					onOpenTaskModal={() => setIsShowUpdateTaskModal(true)}
					taskInputValueFromTaskModal={taskInputValueFromTaskModal}
				/>
			)} */}
			{showAddSamplePopup && (
				<SampleRequestModal
					onClose={() => {
						setShowAddSamplePopup(false);
						setSelectedProducts([]);
					}}
					productIds={getProductIds()}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={SAMPLE_REQUEST_TYPES.SAMPLE}
					title="Send to Sample Section"
					onRefetch={() => onUpdateProductStatus()}
					setSelectedProdutIds={setSelectedProducts}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowReviseSampleModal && (
				<SampleRequestModal
					onClose={() => {
						setIsShowReviseSampleModal(false);
						setSelectedProducts([]);
					}}
					productIds={selectedProducts}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={SAMPLE_REQUEST_TYPES.SEND_REVISE_SAMPLE_REQUEST}
					title="Send to Sample Section"
					onRefetch={() => onUpdateProductStatus()}
					setSelectedProdutIds={setSelectedProducts}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowSendToPdModal && (
				<SampleRequestModal
					onClose={() => {
						setIsShowSendToPdModal(false);
						setSelectedProducts([]);
					}}
					productIds={getProductIds()}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={SAMPLE_REQUEST_TYPES.SEND_TO_PD_IN_HOUSE}
					title="Send to PD"
					taskValueType={SAMPLE_REQUEST_TYPES.SEND_TO_PD_IN_HOUSE}
					onRefetch={() => onUpdateProductStatus()}
					setSelectedProdutIds={setSelectedProducts}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowSendToFactoryNitexModal && (
				<SampleRequestModal
					onClose={() => {
						setIsShowSendToFactoryNitexModal(false);
						setSelectedProducts([]);
					}}
					productIds={getProductIds()}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_NITEX_DESIGN}
					title="Send to Factory (Nitex design Development)"
					onRefetch={() => onUpdateProductStatus()}
					taskValueType={SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_NITEX_DESIGN}
					setSelectedProdutIds={setSelectedProducts}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowSendToFactoryBuyerModal && (
				<SampleRequestModal
					onClose={() => {
						setIsShowSendToFactoryBuyerModal(false);
						setSelectedProducts([]);
					}}
					productIds={getProductIds()}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_BUYER_DESIGN}
					title="Send to Factory (Buyer Techpack)"
					taskValueType={SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_BUYER_DESIGN}
					onRefetch={() => onUpdateProductStatus()}
					setSelectedProdutIds={setSelectedProducts}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowTechpackHandoverModal && (
				<SampleRequestModal
					onClose={() => {
						setSelectedProductActionId(null);
						setIsShowTechpackHandoverModal(false);
						setSelectedProducts([]);
					}}
					productIds={getProductIds()}
					entityId={folderId}
					entityType={ENTITY_TYPE.FAVOURITE_FOLDER}
					requestType={selectedHandoverUserType?.taskValueType?.constant}
					title={selectedHandoverUserType?.name || 'Techpack handover'}
					taskValueType={selectedHandoverUserType?.taskValueType?.constant}
					onRefetch={() => onUpdateProductStatus()}
					setSelectedProdutIds={setSelectedProducts}
					productActionId={selectedProductActionId}
					selectedHandoverUserType={getUserTypeFromTaskValue(
						selectedHandoverUserType?.taskValueType?.constant
					)}
					handoverModalFor={selectedHandoverUserType?.taskValueType?.constant}
					isHandoverModal={true}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowPublishDesign && (
				<PublishDesign
					selectedProducts={selectedProducts}
					onClose={() => {
						dispatch(storeProductData('selectedProductIds', []));
						setIsShowPublishDesign(false);
					}}
					onSubmitSuccess={handleUpdateDesignOnPublish}
				/>
			)}
			{isShowSendTo3DModal && (
				<RequestTo3DAndGraphicsModal
					title="Send 3D design request"
					onClose={() => {
						setIsShowSendTo3DModal(false);
						setSelectedProducts([]);
					}}
					requestType={SAMPLE_REQUEST_TYPES.SEND_TO_3D}
					productIds={getProductIds()}
					onRefetch={() => onUpdateProductStatus()}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowSendToGraphicsModal && (
				<RequestTo3DAndGraphicsModal
					requestType={SAMPLE_REQUEST_TYPES.SEND_TO_GRAPHIC}
					title="Send Graphics team for design & placement"
					onClose={() => {
						setIsShowSendToGraphicsModal(false);
						setSelectedProducts([]);
					}}
					productIds={getProductIds()}
					onRefetch={() => onUpdateProductStatus()}
					onResetError={setFailedTaskUpdateIds}
				/>
			)}
			{isShowPhysicalSampleModal && (
				<PhysicalSampleRequestModal
					onClose={() => {
						setIsShowPhysicalSampleModal(false);
						setSelectedProducts([]);
					}}
					selectedDesigns={getProductIds()}
					setSelectedProdutIds={setSelectedProducts}
				/>
			)}
		</LoaderComponent>
	);
};

export default DesignListV2;
